import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { GzCardWebComponent } from '../../../ui/gzCard';
import { GzButtonWebComponent } from '../../../ui/gzButton';
import { SendFeedbackEmailConstants } from '../SendFeedbackEmailConstants';
import { GzClearableInputWebComponent } from '../../../ui/gzInput';
import { GzTextWebComponent } from '../../../ui/gzText';

export class SendFeedbackEmailWebView extends BaseWebComponentView {
  public dom: {
    $feedbackCard: GzCardWebComponent;
    $input: GzClearableInputWebComponent;
    $wordCounter: GzTextWebComponent;
    $button: GzButtonWebComponent;
  };

  getDomElements() {
    this.dom = {
      $feedbackCard: this.shadow.querySelector('.gz-feedback-card'),
      $input: this.shadow.querySelector('gz-input'),
      $wordCounter: this.shadow.querySelector('gz-text'),
      $button: this.shadow.querySelector('gz-button'),
    };
  }

  getTranslations() {
    this.translations = this.stringsTranslator.getSensorsIntegrationsStrings();
    return this.translations;
  }

  setFeedbackTranslations(card: GzCardWebComponent): void {
    card.name = this.translations.sendFeedback.feedbackName;
    this.dom.$input.placeholder = this.translations.sendFeedback.feedbackDescription;
    this.dom.$button.innerText = this.translations.sendFeedback.feedbackButton;
  }

  getFeedback(): string {
    return this.dom.$input.value.trim();
  }

  buildView() {
    this.buildSuccessView();
  }

  buildSuccessView(): void {
    this.getTranslations();
    this.setFeedbackTranslations(this.dom.$feedbackCard);
  }
}
